import { UseFormSetValue } from "react-hook-form";

import { PosSubscriptionServices } from "globalConstants";
import { SubscriptionOptionsType } from "types";
import { CadenceTypes } from "types/enums";

// Sets the discount based on the cadence, POS System status and Marketing Service status.
// When POS System  and Marketing Services subscriptions are activated together - add default discount
export const setDiscount = (
	sectionValues: SubscriptionOptionsType,
	setValue: UseFormSetValue<any>,
	sectionName: string,
) => {
	const defaultMonthlyDiscount =
		PosSubscriptionServices.PosSystem.discount.monthly;

	const billingCadence = sectionValues?.posSystem?.billingCadence?.name;
	const posSystemStatus = sectionValues?.posSystem?.isSubscribed;
	const marketingServiceStatus =
		sectionValues?.marketingServices?.isSubscribed;

	if (posSystemStatus && marketingServiceStatus) {
		if (billingCadence === CadenceTypes.Monthly.name) {
			setValue(
				`${sectionName}.subscriptions.discount`,
				defaultMonthlyDiscount as never,
			);
		} else {
			setValue(`${sectionName}.subscriptions.discount`, "0.00" as never);
		}
	} else if (
		(posSystemStatus && !marketingServiceStatus) ||
		(!posSystemStatus && marketingServiceStatus)
	) {
		setValue(`${sectionName}.subscriptions.discount`, "0.00" as never);
	}
};
